export const FALLBACK_SIZE = 1600;
export const FALLBACK_FORMAT = 'jpg';
